import { render, staticRenderFns } from "./vuetify-audio.vue?vue&type=template&id=63c79769&"
import script from "./vuetify-audio.vue?vue&type=script&lang=js&"
export * from "./vuetify-audio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports